import {
  AlgoliaSearchAttempt,
  AlgoliaSearchFail,
  AlgoliaSearchSuccess,
  GetAlgoliaKeyAttempt,
  GetAlgoliaKeyFail,
} from '../events/algolia'
import { AppDirBegin, AppDirDisplay } from '../events/appPen'
import {
  IcoBegin,
  IcoBeginKilo,
  IcoBeginProvince,
  IcoBeginVin,
  IcoBOS,
  IcoComplete,
  IcoFaq,
  IcoGetStartedAttempt,
  IcoGetStartedCancel,
  IcoGetStartedFail,
  IcoGetStartedSuccess,
  IcoGetYourOffer,
  IcoPostAdBegin,
  IcoVinHelp,
  PmrBeginKilo,
  PmrBeginProvince,
  PmrBeginVin,
  PmrBOS,
  PmrFaq,
  PmrGetICO,
  PmrGetValueAttempt,
  PmrGetValueCancel,
  PmrGetValueFailure,
  PmrGetValueSuccess,
  PmrPostAdBegin,
  PmrVinHelp,
  ValueEstimateBegin,
  ValueEstimateComplete,
} from '../events/autoCanada'
import {
  CategorySelectAttempt,
  CategorySelectBegin,
  CategorySelectClick,
  CategorySelectFail,
  CategorySelectSuccess,
} from '../events/category'
import { CookieAcknowledge } from '../events/cookies'
import {
  FilterSelectAttempt,
  FilterSelectAttributeAttempt,
  FilterSelectBegin,
  FilterSelectCancel,
  FilterSelectFail,
  FilterSelectReset,
  FilterSelectSuccess,
} from '../events/filter'
import {
  LocationSelectAttempt,
  LocationSelectBegin,
  LocationSelectCancel,
  LocationSelectClick,
  LocationSelectFail,
  LocationSelectSuccess,
} from '../events/location'
import { LoginBegin, LoginFail, LoginSuccess, LogoutSuccess } from '../events/login'
import {
  KijijiMyBusinessOpen,
  MyAccountOpen,
  MyAccountSettingsOpen,
  MyAdsOpen,
  MyOrdersOpen,
} from '../events/myKijiji'
import {
  PasswordResetAttempt,
  PasswordResetFail,
  PasswordResetSent,
  PasswordResetSuccess,
} from '../events/passwordReset'
import { PostAdBegin } from '../events/postAd'
import { PSAClick, PSADismissed, PSALoaded } from '../events/psa'
import {
  SaveSearchBegin,
  SaveSearchDeleteSuccess,
  SaveSearchFail,
  SaveSearchModalCancel,
  SaveSearchModalLoad,
  SaveSearchSuccess,
} from '../events/saveSearch'
import {
  CrossPromoBadgeClick,
  ErrorStateLoad,
  ResultsBrowse,
  ResultsSearch,
  SearchAttempt,
  SearchBegin,
  SelectPromotion,
  TopAdLearnMoreClick,
  ViewPromotion,
} from '../events/search'
import { ShoppingAdClick, ShoppingAdLoaded, ShoppingAdScroll } from '../events/shoppingAd'
import {
  UserActivationFail,
  UserActivationSuccess,
  UserRegistrationAttempt,
  UserRegistrationBegin,
  UserRegistrationFail,
  UserRegistrationSuccess,
} from '../events/userRegistration'
import { WatchlistAdd, WatchlistOpen, WatchlistRemove } from '../events/watchlist'

export type GaEvent = typeof GA_EVENT[keyof typeof GA_EVENT]

export const GA_EVENT = {
  BlockTitleClick: 'BlockTitleClick',
  BrandedCategorySelected: 'BrandedCategorySelected',
  ButtonClick: 'button_click',
  CasBackfillsShowMore: 'ShowMoreAdmarktClick',
  CasBackfillsShowMoreLoad: 'ShowMoreAdmarktLoad',
  CasBackfillsShowMoreView: 'ShowMoreAdmarktView',
  CategorySelected: 'CategorySelected',
  CrossPromoBadgeClick: CrossPromoBadgeClick,
  DownloadAppClick: 'DownloadAppClick',
  HPFLoadMore: 'HPFLoadMore',
  HelpDeskClick: 'HelpDeskClick',
  IcoBOS: IcoBOS,
  IcoBegin: IcoBegin,
  IcoBeginKilo: IcoBeginKilo,
  IcoBeginProvince: IcoBeginProvince,
  IcoBeginVin: IcoBeginVin,
  IcoComplete: IcoComplete,
  IcoFaq: IcoFaq,
  IcoGetStartedAttempt: IcoGetStartedAttempt,
  IcoGetStartedCancel: IcoGetStartedCancel,
  IcoGetStartedFail: IcoGetStartedFail,
  IcoGetStartedSuccess: IcoGetStartedSuccess,
  IcoGetYourOffer: IcoGetYourOffer,
  IcoPostAdBegin: IcoPostAdBegin,
  IcoVinHelp: IcoVinHelp,
  KijijiCentralClick: 'KijijiCentralClick',
  MessageCenterOpen: 'MessageCenterOpen',
  NotificationCentreOpen: 'NotificationCentreOpen',
  PmrBOS: PmrBOS,
  PmrBeginKilo: PmrBeginKilo,
  PmrBeginProvince: PmrBeginProvince,
  PmrBeginVin: PmrBeginVin,
  PmrFaq: PmrFaq,
  PmrGetICO: PmrGetICO,
  PmrGetValueAttempt: PmrGetValueAttempt,
  PmrGetValueCancel: PmrGetValueCancel,
  PmrGetValueFailure: PmrGetValueFailure,
  PmrGetValueSuccess: PmrGetValueSuccess,
  PmrPostAdBegin: PmrPostAdBegin,
  PmrVinHelp: PmrVinHelp,
  RecentAdClick: 'RecentAdClick',
  RecommendationAdClick: 'RecommendationAdClick',
  RecommendedAdClick: 'RecommendedAdClick',
  RecommendedForYouDisplayed: 'RecommendedDisplayed',
  RelatedKeywordClick: 'RelatedKeywordClick',
  ResultsImpressions: 'ResultsImpressions',
  SelectPromotion: SelectPromotion,
  SwapSelected: 'SwapSelected',
  SwitchLanguage: 'SwitchLanguage',
  ValueEstimateComplete: ValueEstimateComplete,
  ViewPromotion: ViewPromotion,
  WantedSelected: 'WantedSelected',
  [AlgoliaSearchAttempt]: AlgoliaSearchAttempt,
  [AlgoliaSearchFail]: AlgoliaSearchFail,
  [AlgoliaSearchSuccess]: AlgoliaSearchSuccess,
  [AppDirBegin]: AppDirBegin,
  [AppDirDisplay]: AppDirDisplay,
  [CategorySelectAttempt]: CategorySelectAttempt,
  [CategorySelectBegin]: CategorySelectBegin,
  [CategorySelectClick]: CategorySelectClick,
  [CategorySelectFail]: CategorySelectFail,
  [CategorySelectSuccess]: CategorySelectSuccess,
  [CookieAcknowledge]: CookieAcknowledge,
  [ErrorStateLoad]: ErrorStateLoad,
  [FilterSelectAttempt]: FilterSelectAttempt,
  [FilterSelectAttributeAttempt]: FilterSelectAttributeAttempt,
  [FilterSelectBegin]: FilterSelectBegin,
  [FilterSelectCancel]: FilterSelectCancel,
  [FilterSelectFail]: FilterSelectFail,
  [FilterSelectReset]: FilterSelectReset,
  [FilterSelectSuccess]: FilterSelectSuccess,
  [GetAlgoliaKeyAttempt]: GetAlgoliaKeyAttempt,
  [GetAlgoliaKeyFail]: GetAlgoliaKeyFail,
  [KijijiMyBusinessOpen]: KijijiMyBusinessOpen,
  [LocationSelectAttempt]: LocationSelectAttempt,
  [LocationSelectBegin]: LocationSelectBegin,
  [LocationSelectCancel]: LocationSelectCancel,
  [LocationSelectClick]: LocationSelectClick,
  [LocationSelectFail]: LocationSelectFail,
  [LocationSelectSuccess]: LocationSelectSuccess,
  [LoginBegin]: LoginBegin,
  [LoginFail]: LoginFail,
  [LoginSuccess]: LoginSuccess,
  [LogoutSuccess]: LogoutSuccess,
  [MyAccountOpen]: MyAccountOpen,
  [MyAccountSettingsOpen]: MyAccountSettingsOpen,
  [MyAdsOpen]: MyAdsOpen,
  [MyOrdersOpen]: MyOrdersOpen,
  [PSAClick]: PSAClick,
  [PSADismissed]: PSADismissed,
  [PSALoaded]: PSALoaded,
  [PasswordResetAttempt]: PasswordResetAttempt,
  [PasswordResetFail]: PasswordResetFail,
  [PasswordResetSent]: PasswordResetSent,
  [PasswordResetSuccess]: PasswordResetSuccess,
  [PostAdBegin]: PostAdBegin,
  [ResultsBrowse]: ResultsBrowse,
  [ResultsSearch]: ResultsSearch,
  [SaveSearchBegin]: SaveSearchBegin,
  [SaveSearchDeleteSuccess]: SaveSearchDeleteSuccess,
  [SaveSearchFail]: SaveSearchFail,
  [SaveSearchModalCancel]: SaveSearchModalCancel,
  [SaveSearchModalLoad]: SaveSearchModalLoad,
  [SaveSearchSuccess]: SaveSearchSuccess,
  [SearchAttempt]: SearchAttempt,
  [SearchBegin]: SearchBegin,
  [ShoppingAdClick]: ShoppingAdClick,
  [ShoppingAdLoaded]: ShoppingAdLoaded,
  [ShoppingAdScroll]: ShoppingAdScroll,
  [TopAdLearnMoreClick]: TopAdLearnMoreClick,
  [UserActivationFail]: UserActivationFail,
  [UserActivationSuccess]: UserActivationSuccess,
  [UserRegistrationAttempt]: UserRegistrationAttempt,
  [UserRegistrationBegin]: UserRegistrationBegin,
  [UserRegistrationFail]: UserRegistrationFail,
  [UserRegistrationSuccess]: UserRegistrationSuccess,
  [ValueEstimateBegin]: ValueEstimateBegin,
  [WatchlistAdd]: WatchlistAdd,
  [WatchlistOpen]: WatchlistOpen,
  [WatchlistRemove]: WatchlistRemove,
} as const
